export default __webpack_public_path__ + "static/media/wind.84ec6def.png";